<script>
/* global axios */
// Aba "DataCrazy" da caixa (v232): mostra de qual número ela é e deixa trocar
// por onde as respostas saem. A ponte (datacrazy-bridge) relê essa escolha a
// cada minuto — trocar aqui vale sem redeploy.
import { useAlert } from 'dashboard/composables';
import NextButton from 'dashboard/components-next/button/Button.vue';

export default {
  components: { NextButton },
  props: {
    inbox: { type: Object, required: true },
  },
  data() {
    return {
      instanceName: '',
      phone: '',
      route: 'datacrazy',
      loaded: false,
      saving: false,
    };
  },
  computed: {
    accountId() {
      return this.$route.params.accountId;
    },
  },
  mounted() {
    this.load();
  },
  methods: {
    async load() {
      try {
        const { data } = await axios.get(
          `/api/v1/accounts/${this.accountId}/datacrazy/config`,
          { params: { inbox_id: this.inbox.id } }
        );
        this.instanceName = data.instance_name || '';
        this.phone = data.phone || '';
        this.route = data.route || 'datacrazy';
        this.loaded = true;
      } catch (error) {
        useAlert(
          error?.response?.data?.error ||
            'Não consegui carregar a configuração desta caixa.'
        );
      }
    },
    async save() {
      this.saving = true;
      try {
        await axios.post(
          `/api/v1/accounts/${this.accountId}/datacrazy/config`,
          { inbox_id: this.inbox.id, route: this.route }
        );
        useAlert('Rota de envio salva. Vale para as próximas respostas.');
      } catch (error) {
        useAlert(
          error?.response?.data?.error || 'Não consegui salvar a rota de envio.'
        );
      } finally {
        this.saving = false;
      }
    },
  },
};
</script>

<template>
  <div v-if="loaded" class="py-6">
    <div class="mb-6">
      <h4 class="text-base font-medium text-n-slate-12">Número</h4>
      <p class="text-sm text-n-slate-11">
        {{ instanceName || 'Instância da DataCrazy' }}
        <template v-if="phone"> — {{ phone }}</template>
      </p>
    </div>

    <h4 class="text-base font-medium text-n-slate-12">Rota de envio</h4>
    <p class="text-sm text-n-slate-11 mb-3">
      Por onde saem as respostas da IA e dos atendentes desta caixa. O que o
      cliente escreve chega aqui sempre pela DataCrazy.
    </p>

    <label class="flex items-start gap-2 font-normal cursor-pointer">
      <input v-model="route" type="radio" value="datacrazy" class="mt-1" />
      <span>
        <strong>Passando pela DataCrazy</strong>
        <span class="block text-sm text-n-slate-11">
          O atendimento inteiro aparece no painel deles. O envio é só texto:
          anexo vira link e botões viram lista numerada. Compartilha o limite de
          requisições com a leitura (cerca de 4 a 5 mensagens por minuto).
        </span>
      </span>
    </label>

    <label class="flex items-start gap-2 mt-3 font-normal cursor-pointer">
      <input v-model="route" type="radio" value="meta" class="mt-1" />
      <span>
        <strong>Direto pela Meta</strong>
        <span class="block text-sm text-n-slate-11">
          Imagem, áudio e botões de verdade, sem limite prático de envio — usa
          as credenciais do próprio número. Em troca, o painel da DataCrazy não
          mostra as respostas; o histórico completo fica aqui.
        </span>
      </span>
    </label>

    <div class="mt-5">
      <NextButton
        :is-loading="saving"
        type="button"
        solid
        blue
        label="Salvar rota"
        @click="save"
      />
    </div>
  </div>
</template>
